module.exports = __webpack_public_path__ + "static/img/Tech_02.60601907.png";